import { useEffect } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { useNavigate, useLocation } from "react-router-dom";

import { LegacyRoute } from "legacyRoutes";
import { ALL_ACTIVITIES_SCOPE } from "org/controlActivities/list/consts";
import { buildControlActivitiesListUrl } from "org/controlActivities/urlUtils";
import {
    handleNotifications,
    NotificationType,
    notificationTypes,
} from "org/dashboardPendingActivities/notifications";
import { dashboardPendingActivitiesUrl } from "org/dashboardPendingActivities/urlUtils";
import { navigateTo } from "utils/legacyNavigation";

import { OrgApplicationBar } from "../../components/applicationBar/orgApplicationBar";
import Activity from "../../img/activity.svg";
import EventLog from "../../img/event-log.svg";
import { WebRoute } from "../../routes";
import { useFeatureFlag } from "../../utils/hooks/useFeatureFlag";
import { useNewMenu } from "../navigation/useNewMenu";

import { MenuBadgeWrapper } from "./components/MenuBadgeWrapper";
import { DashboardOverviewContainer } from "./DashboardOverviewContainer";

export function DashboardOverviewPage() {
    const { t } = useTranslation();

    const location = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const hasNotification = Array.from(params.keys()).some((key) =>
            notificationTypes.includes(key as NotificationType)
        );
        if (hasNotification) {
            handleNotifications();
        }
    }, [location.search]);

    //Application Bar
    const navigate = useNavigate();

    const controlHealthDashboard = useFeatureFlag("controlHealthDashboard");
    const newMenu = useNewMenu();

    return (
        <>
            <OrgApplicationBar
                title={t("Dashboard_Title")}
                navigation={{
                    type: "Tabs",
                    currentTabId: "tab-overview",
                    tabSpecs: [
                        {
                            id: "tab-overview",
                            label: t("Dashboard_Title_V2"),
                            onClick: () => navigate(WebRoute.DASHBOARD_V2),
                        },
                        ...(controlHealthDashboard
                            ? [
                                  {
                                      id: "tab-control-health",
                                      label: t("ControlHealth_Title"),
                                      onClick: () =>
                                          navigate(WebRoute.CONTROL_HEALTH),
                                  },
                              ]
                            : []),
                        {
                            id: "tab-dashboard",
                            label: t("Dashboard_ControlPrograms_Title"),
                            onClick: () =>
                                navigateTo(LegacyRoute.DASHBOARD_NO_REDIRECT),
                        },
                        {
                            id: "tab-pending-actions",
                            label: <MenuBadgeWrapper />,
                            onClick: () =>
                                navigate(dashboardPendingActivitiesUrl),
                        },
                    ],
                }}
                actions={{
                    id: "dashboard-actions",
                    actions: [
                        {
                            id: "action-activities",
                            label: t("ViewControlProgram_ViewResults"),
                            link: {
                                to: buildControlActivitiesListUrl(
                                    ALL_ACTIVITIES_SCOPE
                                ),
                            },
                            icon: { svg: Activity },
                        },
                        {
                            id: "action-event-log",
                            label: newMenu
                                ? t("Navigation_AuditTrail")
                                : t("Dashboard_EventLog"),
                            link: { to: "/events" },
                            icon: { svg: EventLog },
                        },
                    ],
                }}
            >
                <DashboardOverviewContainer />
            </OrgApplicationBar>
        </>
    );
}
